import FullWidthHeader from "@components/BasicComponents/FullWidthHeader/FullWidthHeader"
import OpenApplicationContentSection from "@components/Pages/OpenApplication/OpenApplicationContentSection/OpenApplicationContentSection"
import OpenApplicationFormSection from "@components/Pages/OpenApplication/OpenApplicationFormSection/OpenApplicationFormSection"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import getValueOrThrow from "@helpers/getValueOrError"
import {getTranslatedPageData} from "@hooks/PagesData/getTranslatedPageData"
import OpenApplicationCategoriesJson from "@jsons/applicationCategories.json"
import OpenApplicationJson from "@jsons/openApplication.json"
import React from "react"

type Props = {}

const openApplication = (props: Props) => {
	const AuditorsSection = getTranslatedPageData(
		OpenApplicationJson,
		true,
		true,
	)

	const AuditorsSections = getValueOrThrow(AuditorsSection.AdvancedSideAsset)

	const mainContent = getValueOrThrow(AuditorsSections[0].mainContent)

	const translatedJobCategories = getPosts("CategoriesModule", {
		data: OpenApplicationCategoriesJson,
	})

	return (
		<>
			<HeadMeta meta={AuditorsSection.metaData} />

			<FullWidthHeader
				data={{
					title: AuditorsSections[0].sectionTitle,
					subtitle: AuditorsSections[0].sectionBottomSubtitle,
				}}
				position={"left"}
				size={"L"}
			/>

			<OpenApplicationContentSection data={mainContent?.[0]} />
			<OpenApplicationFormSection categories={translatedJobCategories} />
		</>
	)
}

export default openApplication
